var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalcaregivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95326 2.18881C9.34094 2.76226 9.56709 3.44878 9.56709 4.19184C9.55901 6.13026 8.03251 7.70522 6.11025 7.76983C6.02948 7.76176 5.93256 7.76176 5.84372 7.76983C4.91667 7.73836 4.03828 7.34729 3.39455 6.67944C2.75083 6.0116 2.39232 5.11942 2.39495 4.19184C2.39495 2.21304 3.99414 0.605774 5.98102 0.605774M11.9675 2.22112C13.5344 2.22112 14.7943 3.48917 14.7943 5.04797C14.7943 6.57448 13.5828 7.81829 12.0725 7.87483C12.0027 7.86675 11.9323 7.86675 11.8625 7.87483M13.5255 15.1439C14.107 15.0227 14.6562 14.7885 15.1085 14.4412C16.3685 13.4962 16.3685 11.9374 15.1085 10.9924C14.6643 10.6532 14.1232 10.4271 13.5497 10.2978M2.07188 10.7501C0.117315 12.0586 0.117315 14.1908 2.07188 15.4912C4.29298 16.9773 7.93559 16.9773 10.1567 15.4912C12.1113 14.1828 12.1113 12.0505 10.1567 10.7501C7.94367 9.2721 4.30106 9.2721 2.07188 10.7501Z",
    stroke: "#315E45",
    strokeWidth: 1.21151,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.07242,
    cy: 4.03256,
    r: 3.08951,
    fill: "#E1F4D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalcaregivers);
export default __webpack_public_path__ + "static/media/totalcaregivers.96f9920f864afa3e16f5d858dd21abd9.svg";
export { ForwardRef as ReactComponent };